import * as React from 'react'
import { css, SerializedStyles } from '@emotion/react'

type Props = {
  height?: number
  width?: number
  color?: string
  additionalStyles?: SerializedStyles
  onClick?: any
}

export const DefaultUserIcon = ({
  height = 20,
  width = 20,
  color,
  onClick = () => {},
  additionalStyles,
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
    >
      <rect width="30" height="30" fill="#E5E6E7" />
      <path
        d="M5 30H25V25C24.9979 23.1441 24.2597 21.3649 22.9474 20.0526C21.6351 18.7403 19.8559 18.0021 18 18H12C10.1441 18.0021 8.36489 18.7403 7.05259 20.0526C5.7403 21.3649 5.00212 23.1441 5 25V30ZM8 9C8 10.3845 8.41054 11.7378 9.17971 12.889C9.94888 14.0401 11.0421 14.9373 12.3212 15.4672C13.6003 15.997 15.0078 16.1356 16.3656 15.8655C17.7235 15.5954 18.9708 14.9287 19.9497 13.9497C20.9287 12.9708 21.5954 11.7235 21.8655 10.3656C22.1356 9.00776 21.997 7.6003 21.4672 6.32122C20.9373 5.04213 20.0401 3.94888 18.889 3.17971C17.7378 2.41054 16.3845 2 15 2C13.1435 2 11.363 2.7375 10.0503 4.05025C8.7375 5.36301 8 7.14348 8 9Z"
        fill="#B4B4B5"
      />
    </svg>
  )
}
